var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('a',{attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();_vm.openTodayModal(), _vm.clickButton()}}},[_c('span',{staticClass:"new"},[_vm._v("NEW")]),_c('span',{staticClass:"color-yellow"},[_vm._v("今夜の")]),_vm._v("宿泊予約をする"),_c('small',[_vm._v("（最安値価格表示あり）")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }